<div class="searchBoxWrapper">
  <ul>
    <li *ngFor="let recordOption of searchResults" (click)="execute.emit(recordOption)">
      {{ recordOption.formattedValue || recordOption.value }}
    </li>
  </ul>
  <span *ngIf="!searchResults.length" l10nTranslate>shared.noRecords</span>
  <ng-container *ngIf="footerElements && footerElements.length">
    <div class="divider"></div>
    <ng-container *ngFor="let element of footerElements" [ngSwitch]="element.type">
      <ng-container *ngSwitchCase="elementType.Text">
        <span [className]="element.class || ''">{{ element.title }}</span>
      </ng-container>
      <ng-container *ngSwitchCase="elementType.Button">
        <div [className]="element.class || ''" (click)="customCommand.emit(element.command)">
          <mat-icon *ngIf="element.icon" svgIcon="{{ element.icon }}"></mat-icon>
          <span>{{ element.title }}</span>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <span [className]="element.class || ''">{{ element.title }}</span>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
